import findControlsFor from '../filters/find-controls-for';
import controlTypes from '../constants/control-types';

const getExtensionControlsForElement = (element) => findControlsFor(element, controlTypes.ELEMENT);

export default getExtensionControlsForElement;
